import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import SurveyList from './components/SurveyList';
import SurveyBuilder from './components/SurveyBuilder';
import SurveyRunner from './components/SurveyRunner';
import ResponsesList from './components/ResponsesList';
import PublicSurveyList from './components/PublicSurveyList';
import PublicSurveyRunner from './components/PublicSurveyRunner';
import './App.css';

function Navigation() {
  const location = useLocation();
  
  // Don't show navigation on survey taking page or public routes
  if (location.pathname.startsWith('/survey/') || location.pathname.startsWith('/public')) {
    return null;
  }

  return (
    <nav className="navbar">
      <div className="nav-container">
        <img src="/Aqlyze-logo.png" alt="Aqlyze" className="nav-logo" />
        <div className="nav-links">
          <Link 
            to="/" 
            className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
          >
            Forms
          </Link>
          <Link 
            to="/responses" 
            className={`nav-link ${location.pathname === '/responses' ? 'active' : ''}`}
          >
            Responses
          </Link>
        </div>
      </div>
    </nav>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />

        <div className="content">
          <Routes>
            <Route path="/public" element={<PublicSurveyList />} />
            <Route path="/public/survey/:id" element={<PublicSurveyRunner />} />
            <Route path="/" element={<SurveyList />} />
            <Route path="/builder" element={<SurveyBuilder />} />
            <Route path="/builder/:id" element={<SurveyBuilder />} />
            <Route path="/survey/:id" element={<SurveyRunner />} />
            <Route path="/responses" element={<ResponsesList />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
